import { ICloneable } from '../../contracts/cloneable.js';
import { IDataComparable } from '../../contracts/data-comparable.js';
import { MapUtils } from '../../utility/map-utils.js';
import { isNullOrUndefined } from '../../utility/null-safety.js';
import { SerializedData } from '../dto/dto.js';

export class Vec2 implements IDataComparable, ICloneable {
  constructor(
    public x: number,
    public y: number,
  ) {}

  static origin(): Vec2 {
    return new Vec2(0, 0);
  }

  static i(): Vec2 {
    return new Vec2(1, 0);
  }

  static j(): Vec2 {
    return new Vec2(0, 1);
  }

  static fromJsonOrNull(data: SerializedData | null): Vec2 | null {
    return isNullOrUndefined(data) ? null : Vec2.fromJson(data);
  }

  static fromJson(data: SerializedData): Vec2 {
    return new Vec2(
        MapUtils.getNumber(data, 'x'),
        MapUtils.getNumber(data, 'y'),
    );
  }

  toJson(): SerializedData {
    return {
      x: this.x,
      y: this.y,
    };
  }

  add(other: Vec2): Vec2 {
    return new Vec2(this.x + other.x, this.y + other.y);
  }

  sub(other: Vec2): Vec2 {
    return new Vec2(this.x - other.x, this.y - other.y);
  }

  length(): number {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }

  clone(): this {
    return new Vec2(this.x, this.y) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return this.x === other.x && this.y === other.y;
  }
}
